import React, { useState, useEffect } from "react";
import { nanoid } from 'nanoid';
import Box from "@material-ui/core/Box";

import useStyleRcollection from "../styles/useStyleRcollection";

import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import InputBase from "@material-ui/core/InputBase";
import { Button } from "@material-ui/core";

import SearchIcon from "@material-ui/icons/Search";
import CancelIcon from "@material-ui/icons/Cancel";

import { CircularProgress, Grid } from "@material-ui/core";

import RCard from "./RCard";

import ReadDB from "../actions/ReadDB";

const Rcollection = (props) => {
  const classes = useStyleRcollection();

  //preparo il filtro che utilizzerò nel campo 'search' nella Navbar
  const [filter, setFilter] = useState("");

  // filtro per la 'ricerca' delle ricerche
  const [ricerche, setRicerche] = useState([]);

  //const [tags, setTags] = useState(RData);
  const [tags, setTags] = useState(ricerche);

  //Parola chiave selezionata
  const [pChiave, setPChiave] = useState("");

  //****************************************************************************
  // Con useEffect() al primo render chiamo ReadDB() che assegna a ricerche il
  // contenuto. tags viene riempito sfruttando localStorage che è stato "chiamato"
  // la prima volta da ReadDB().
  //****************************************************************************
  useEffect(() => {
    ReadDB(setRicerche);
    console.log("eccoci");
    setTags(JSON.parse(localStorage.getItem("tags")));
    //setTags(ricerche);
  }, []);

  //****************************************************************************
  // Resetto l'Array dove cercare i titoli
  // e aspetto i caratteri che mi vengono passati dall'InputBase
  //****************************************************************************

  const handleSearchChange = (e) => {
    // l'InputBase invia tutto quello che inserisco e lo immetto nell'hook filter

    handleNoTag();
    setFilter(e.target.value); //caratteri inseriti dall'utente
  };
  //****************************************************************************

  const handleNoTag = () => {
    setPChiave(""); //azzero l'eventuale presenza di una Parole_Chiave
    setRicerche(tags); // Riempio nuovamente ricerche con TUTTI i record
  };

  //ordino i dati secondo la data in ordine decrescente
  ricerche.sort(
    (a, b) => parseFloat(b.anno_di_avvio) - parseFloat(a.anno_di_avvio)
  );

  return (
    <>
      <AppBar position="relative" elevation={0} color="transparent">
        <Toolbar>
          <div className={classes.search}>
            <div className={classes.searchIcon}>
              <SearchIcon />
            </div>

            <InputBase
              onChange={handleSearchChange}
              placeholder="cerca nel titolo…"
              inputProps={{
                // root: classes.inputRoot,
                // input: classes.inputInput,
                "aria-label": "search", 
              }}
              classes={{
                input: classes.inputInput,
                root: classes.inputRoot,
              }}              
            />
          </div>
          {pChiave && (
            <Button
              variant="contained"
              color="default"
              className={classes.button}
              disableElevation
              startIcon={<CancelIcon />}
              onClick={handleNoTag}
            >
              {pChiave}
            </Button>
          )}
        </Toolbar>
      </AppBar>
      <Box>
        {ricerche ? (
          <Grid
            container
            lg={12}
            className={classes.desk}
            justify={"center"}
            item={true}
          >
            {/* leggo tutti gli elementi e li passo a RCard per 'vestirli' */}

            {
              /* funziona per cercare il titolo della ricerca*/
              /* per evitare problemi con maiuscole e minuscole nel titolo */
              /* trasformo tutto in minuscolo */
              /* l'array ricerche è quello che manipolo per cercare tra gli items*/
              /* Al Component 'RCard' invio l'object ricerca, e due hook, setRicerche e setPChiave in modo da modificare gli Array sia delle ricerche che delle parole chiave e gestire cosa vedo*/

              ricerche.map(
                (ricerca) =>
                  ricerca.titolo
                    .toLowerCase()
                    .includes(filter.toLowerCase()) && (
                    <RCard
                      ricerca={ricerca}
                      key={nanoid()}
                      settags={setRicerche}
                      tag={setPChiave}
                      {...props}
                    />
                  )
              )
            }

            {/*
              tags.map((ricerca) =>
                <RCard
                  ricerca = {ricerca}
                  key = {ricerca.id}
                  settags = {setTags}
                  {...props}
                />
              )*/}
          </Grid>
        ) : (
          <CircularProgress />
        )}
      </Box>
    </>
  );
};

export default Rcollection;
